
import { isEmpty } from 'lodash';
import moment from 'moment';

export const GetCarsDatediff = (pickUp: string, dropOff: string) => {
  return moment(dropOff, 'yyyy-MM-DD').diff(moment(pickUp, 'yyyy-MM-DD'), 'days');
}

export const GetCarTimeAsNumber = (time: string) => {
  return !isEmpty(time) ? Number(time?.replaceAll(':', '')) : undefined;
}

